import styled from 'styled-components';
import { IBlurProps, useBlurCss } from '../../fundamentals/blurs/blurs';
import { Z_INDICES } from '../../common/constants';
import { rgba } from 'polished';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { IColoursCollection } from '../../fundamentals/colours/colourInterfaces';
import { BaseDiv } from '../../common/BaseElements';

export interface IOverlayProps extends IBlurProps {
  inverse?: boolean;
}

export const overlayColours = ({ base }: IColoursCollection) => ({
  overlayColours: {
    background: rgba(base.black.colour, 0.7)
  }
});

export const Overlay = styled(BaseDiv).attrs<IOverlayProps>(({ inverse, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Overlay');
  return {
    ...rest,
    ...generateTestId()
  };
})<IOverlayProps>`
  z-index: ${Z_INDICES.OVERLAY};
  background: ${({ theme }) => theme.colours.eoraCoreColours.OPACITIES.COLOR_DARK_OPACITY_70_NOSWITCH};
  top: 0;
  left: 0;
  position: fixed;
  bottom: 0;
  right: 0;
  ${useBlurCss};
`;
